import '../assets/css/sub-pages.css'
import Section6 from '../pages/homepage/Section6'
import Section3DM from '../pages/products-pages/Section3DM'
import { Helmet } from 'react-helmet'
import Section1 from '../components/features-component/Section1'
import Section2 from '../components/features-component/Section2'
import Section3 from '../components/features-component/Section3'
import Section4 from '../components/features-component/Section4'
import Section5 from '../components/features-component/Section5'
import FeaturesSlider from '../components/features-component/FeaturesSlider'
import Faqs from '../components/features-component/Faqs'
import Feature2 from '../assets/images/fin-rec-asset/Dispute/Automated Appeals & Evidence Submission.webp'
import Feature1 from '../assets/images/fin-rec-asset/Dispute/Automated Order Error Identification.webp'
import Feature3 from '../assets/images/fin-rec-asset/Dispute/Enhanced Proof with CCTV Integration.webp'
import Feature4 from '../assets/images/fin-rec-asset/Dispute/Real-Time Dispute Tracking & Reporting.webp'
import Play_btn from './../assets/images/play_supply.svg'
import YThumb_DM from './../assets/images/dispute-manager-thumb.png'

const DisputeNew = () => {

    const sec1data = {
        heading: "Voosh Automated Dispute Resolution",
        subText: "Restaurants lose billions each year due to unresolved and mishandled disputes with third-party delivery apps. Hidden order errors, ineffective manual appeals, and misconceptions can significantly impact your profitability. Voosh's Automated Dispute Resolution identifies, appeals, and recovers disputed orders seamlessly, ensuring your revenue remains protected.",
        btnText: "Start My Dispute Automation",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
        ytVideoID: "Bq_P_IxWdpw",
        thumbnail: YThumb_DM,
        thumbText: "Lost Profits in Restaurants?🍕...",
        playBtn: Play_btn,
    }

    const s2SecHead = {
        subHead: "Why AI-Powered Dispute Resolution?",
        heading: "Recover every rightful dollar, automatically.",
        p1: "Instantly Identify Order Errors",
        p2: "Eliminate Manual Appeals",
        p3: "Improve Win Rates with Evidence Automation",
        p4: "Real-Time Dispute Tracking",
    }

    const s2CardContents = [
        {
            id: '01',
            title: 'Automated Order Error Identification',
            image: Feature1,
            Problem: 'Manual identification of order errors across multiple delivery apps is inefficient and often ineffective, resulting in significant lost revenue.',
            Solution: "Voosh automatically scans orders from third-party platforms, accurately identifies discrepancies, and initiates disputes promptly.",
            Benefits: 'Recover up to 8% of your order revenue, reduce manual oversight, and ensure rapid response to disputes.',
            p1: 'Spot payout discrepancies instantly',
            p2: 'Track hidden charges and adjustments clearly',
            p3: 'Automate accounting entries',
        },
        {
            id: '02',
            title: 'Automated Appeals & Evidence Submission',
            image: Feature2,
            Problem: 'Manual appeals require considerable effort and rarely achieve optimal recovery, leading to persistent financial loss.',
            Solution: "Voosh automatically submits appeals with compelling evidence directly to delivery apps—ensuring maximal dispute recovery.",
            Benefits: 'Save valuable time, increase dispute win rates, and effortlessly reclaim revenue lost due to order errors.',
            p1: 'Identify order discrepancies in real-time',
            p2: 'Reduce manual verification processes',
            p3: 'Quickly recover lost revenue',
        },
        {
            id: '03',
            title: 'Enhanced Proof with CCTV Integration',
            image: Feature3,
            Problem: 'Proving the legitimacy of disputed orders manually can be challenging, often causing restaurants to lose rightful revenue.',
            Solution: "Voosh integrates directly with your kitchen's CCTV system, automatically capturing and submitting visual proof to delivery platforms.",
            Benefits: 'Achieve near 100% dispute recovery on legitimate claims, safeguard against false disputes, and maintain complete transparency.',
            p1: 'Automatically detect delayed or missing deposits',
            p2: 'Streamline reconciliation processes',
            p3: 'Ensure daily cash flow accuracy',
        },
        {
            id: '04',
            title: 'Real-Time Dispute Tracking & Reporting',
            image: Feature4,
            Problem: 'Lack of real-time visibility into dispute statuses and outcomes can result in reactive management and missed recovery opportunities.',
            Solution: "Voosh provides a centralized, real-time dashboard tracking every dispute, resolution status, and recovered funds.",
            Benefits: 'Gain clarity on dispute outcomes, monitor dispute trends, and consistently improve your revenue recovery performance.',
            p1: 'Eliminate manual journal entry',
            p2: 'Ensure precise financial records',
            p3: 'Scale effortlessly with your business',
        },
    ]

    const sec3data ={
        heading: "Common Misconceptions",
        subHead1: "Misconception",
        p1: "Disputes happen between restaurants and customers.",
        subHead2: "Reality",
        p2: "Order disputes occur exclusively between restaurants and third-party delivery apps. Customers are never directly involved.",
        btnText: "See Why Manual Disputing is Inefficient",
        btnLink: "https://voosh.ai/blogs/a-step-by-step-guide-to-disputing-order-errors-on-doordash-and-ubereats",
    }

    const sec4data = {
        heading: "Why Operations Teams Choose Voosh",
        subHead1: "Proven Results",
        p1: "Recover an average of 2% to 8% of order revenues, reducing significant annual losses.",
        subHead2: "Fully Automated",
        p2: "Eliminate manual dispute processes entirely, freeing your staff to focus on restaurant operations.",
        subHead3: "Integrated Evidence",
        p3: "Maximize dispute legitimacy with automated CCTV integrations and evidence submission.",
    }

    const sec5data = {
        heading: "Ready to protect your restaurant's bottom line?",
        subText: "Schedule your personalized demo to see how Voosh's Automated Dispute Resolution ensures you never miss a dollar that's rightfully yours.",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018",

    }

    const faq_data = [
        {
            id: '0',
            head: 'What exactly is Automated Dispute Resolution?',
            body: "It's Voosh's seamless system to identify, appeal, and recover revenue from disputed orders automatically, maximizing your profitability."
        },
        {
            id: '1',
            head: "How quickly can Voosh recover disputed revenue?",
            body: "Recovery begins immediately upon dispute identification, typically seeing substantial improvements within the first few weeks."
        },
        {
            id: '2',
            head: "Can Voosh integrate with my existing systems?",
            body: "Yes, Voosh effortlessly integrates with your existing POS, CCTV, and third-party delivery platforms for a smooth operation."
        },
        {
            id: '3',
            head: "Is my dispute data secure with Voosh?",
            body: "Absolutely. Voosh ensures your sensitive dispute information remains confidential and fully secure through advanced data protection practices."
        }
      ]

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <Helmet>
        <title>Dispute Manager: Protecting Your Restaurant's Bottom Line</title>
        <meta name='description' content="Seamlessly manage and resolve disputes to protect your restaurant's earnings with Voosh's Dispute Manager" />
        <meta name='keywords' content='Voosh Solutions, Voosh Features, Restaurant Technology, 3rd Party Marketplace Management, Data-Driven Decisions, Restaurant Operations, Restaurant Profitability' />
      </Helmet>
      <Section1 datas = {sec1data} />
      <Section2 s2Contents = {s2CardContents} datas = {s2SecHead} />
      <Section3 datas = {sec3data} />
      <Section3DM />
      <Section4 datas = {sec4data} />
      <Section5 datas = {sec5data} />
      <FeaturesSlider />
      <Faqs datas={faq_data} />
      <Section6 />
    </div>
  )
}

export default DisputeNew
